import { Fragment, memo, useMemo } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useFormatLocale } from '../../../locale/formatting/useFormatLocale';
import { getDaysOfWeek } from '../../DatePicker/DateUtil';
import bundle from '../NovaComponents-Calendar-gui-icu.properties';
import cn from '../Calendar.css.json';
import '../Calendar.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const WeekdayHeaderCells = /*#__PURE__*/memo(function WeekdayHeaderCells(props) {
  const localize = useTextLocalizer();
  const locale = useFormatLocale();
  const weekdays = useMemo(() => getDaysOfWeek(locale), [locale]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [props.showWeekNumbers ? /*#__PURE__*/_jsx("div", {
      role: "gridcell"
    }) : null, [0, 1, 2, 3, 4, 5, 6].map(weekdayIndex => /*#__PURE__*/_jsx("div", {
      id: props.month ? `${props.dayOfWeekIds[weekdayIndex]}-${props.month}` : `${props.dayOfWeekIds[weekdayIndex]}`,
      role: "columnheader",
      "aria-label": localize(`weekday.${(weekdayIndex + props.firstDayOfWeek) % 7}.aria`),
      className: cn.weekdayHeaderCell,
      style: {
        gridColumnStart: `day-start ${1 + weekdayIndex}`
      },
      children: weekdays[(weekdayIndex + props.firstDayOfWeek) % 7]
    }, weekdayIndex))]
  });
});
//# sourceMappingURL=WeekDayHeaderCells.js.map